import { LineItemSupplier } from "elephant-web/gql";
import { array, boolean, number, object, string } from "yup";

export const useValidationSchema = () => {
  return object({
    lineItems: array().of(
      object({
        automated: boolean(),
        id: string(),
        quantity: number().min(1).required(),
        // Required: null-supplier rows (auto-generated) are defaulted to
        // GOVERNMENT on read (useFetchInvoice) so they stay valid.
        supplier: string().oneOf(Object.values(LineItemSupplier)).required(),
        priceListItem: object()
          .shape({
            uuid: string().when("automated", {
              is: true,
              then: (schema) => schema.required(),
              otherwise: (schema) => schema.nullable(true),
            }),
            revenueDepartment: string().when("automated", {
              is: true,
              then: string().required(),
              otherwise: string().nullable(),
            }),
            activeTariffId: string().when("automated", {
              is: true,
              then: string().required(),
              otherwise: string().nullable(),
            }),
          })
          .required(),
      }),
    ),
  });
};
